import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { requestList as request } from 'api/admin';
import ActionButton from 'components/common/ActionButton';
import ListInContent from 'components/common-sfims/ListInContent';
import columns from 'components/pages/admin/columns';
import { utc2tz } from 'function/convert';
import { getText } from 'function/language';
import useListScroll from 'hooks/useListScroll';
import { RESPONSE_CODE, ROUTER_PATH } from 'types/const';
import { RETURN_YN } from 'types/type';
import pluck from 'utils/array/pluck';
import format from 'utils/string/format';

/**
 * 관리자 페이지 - 목록
 */
const List = () => {
  /* hook */
  const { end, setEnd, setTotal } = useListScroll();

  /* router */
  const history = useHistory();

  /* state */
  // 목록
  const [datas, setDatas] = useState([]);
  // 로딩 여부
  const [isLoading, setIsLoading] = useState(true);
  // 메시지
  const [message, setMessage] = useState({});

  /* watch */
  useEffect(() => {
    requestList();
  }, []);

  /* method */
  // 사용자 목록 조회 요청
  const requestList = async () => {
    setEnd(20);
    setTotal(0);
    setDatas([]);
    setIsLoading(true);
    setMessage({});

    try {
      const { list = [], totalCount = 0, code, message } = await request();

      if (code !== RESPONSE_CODE.Success) {
        throw {
          code,
          error: message
        };
      }

      setTotal(totalCount);
      setDatas(
        list.map((value = {}, index) => ({
          ...value,
          rowNum: totalCount - index,
          authList: pluck(value.authList, 'pltCode').join(', '),
          loginDt: utc2tz(value.loginDt),
          regDt: utc2tz(value.regDt)
        }))
      );
    } catch (error) {
      setMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  /* event */
  // 등록/수정 클릭 시
  const onSettingClick = seq => {
    history.push(format(ROUTER_PATH.admin.setting, { seq }));
  };

  return (
    <ListInContent
      columns={Object.keys(columns)}
      message={message}
      showLoading={isLoading}
    >
      <Fragment key="headerButton">
        <Button size="sm" className="ms-2" onClick={() => onSettingClick()}>
          + {getText('insert')}
        </Button>
      </Fragment>
      <Fragment key="datas">
        {datas.slice(0, end).map((value = {}) => (
          <tr
            key={`datas${value.seq}`}
            className={
              value.useYn === RETURN_YN.Y ? 'bg-soft-success' : 'bg-200'
            }
          >
            {Object.entries(columns).map(([key, { className } = {}]) => (
              <td key={`datas${value.seq}.${key}`} className={className}>
                {key === 'update' ? (
                  <ActionButton
                    title={getText('update')}
                    icon="edit"
                    variant="action"
                    className="p-0 lh-1"
                    onClick={() => onSettingClick(value.seq)}
                  />
                ) : (
                  value[key]
                )}
              </td>
            ))}
          </tr>
        ))}
      </Fragment>
    </ListInContent>
  );
};

export default List;
